<script>
import ChangePasswordForm from '@/components/ChangePasswordForm.vue'
import { mapGetters } from '../store'

export default {
    name: 'ChangePassword',
    components: {
        ChangePasswordForm,
    },
    computed: {
        ...mapGetters(['userResource'])
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        onSuccess() {
            this.addSuccess('Password successfully updated')
        },
    },
    async mounted() {
        
    },
}
</script>

<template>
    <div v-page-title="'Change Password'">
        <b-row>
            <b-col class="section-heading">
                <h4>Change Password</h4>
                <hr />
            </b-col>
        </b-row>
        
        <b-row>
            <b-col md="6">
                <change-password-form v-if="userResource" @success="onSuccess" :userResource="userResource" />
                <p v-else class="text-center">Loading...</p>
                <messages class="mt-3" />
            </b-col>
        </b-row>
    </div>
</template>

<style scoped>

</style>
